'use strict';

import ReactDOM from 'react-dom';
import React, { Component } from 'react';
import { Navbar, NavbarNav, Collapse, NavItem, NavLink, Container } from 'mdbreact';
import { BrowserRouter as Router } from 'react-router-dom';

import { css } from 'emotion';

import ImageCard from './ImageCardContainer';


let jsonData = require('./landingpagedata.json');
const envisionIcon = '/assets/img/envision-white-on-dark.svg';
import $ from 'jquery';

export default class EnvisionNav extends Component {

  constructor(props) {
    super(props);
    let ani = this.props.animate;
    this.state = {
      animate: !ani ? false : this.props.animate,
      collapse: false,
      isWideEnough: false,
      serviceText: jsonData.Header.NavigationTexts.serviceLink.text,
      aboutText: jsonData.Header.NavigationTexts.aboutLink.text,
      contactText: jsonData.Header.NavigationTexts.contactLink.text
    };
    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    this.setState({
      collapse: !this.state.collapse,
    });

    $('.animated-icon3').toggleClass('open');
    if (!this.state.collapse) {
      $('.navbar').addClass('light-blue-envision');
    }
  }

  /*Fancy burger
  https://codepen.io/vineethtr/pen/VYRzaV
  <Navbar transparent scrolling>
  */
  render() {
    return (
    <Router forceRefresh={true} style={{flex: '1'}}>
        <Navbar id="navbar"
          style={{paddingLeft: '1.8rem', paddingRight:'1.8rem', fontSize:'2rem'}}
          color="light-blue-envision"
          dark
          expand="sm"
          fixed="top">
          <Container style={{paddingLeft:'0',marginLeft:'0'}}>
            <a  href="/" style={{marginRight:'2rem',color:'white',textDecoration:'none',fontSize:'1.9rem',fontWeight:'500'}}>
              <ImageCard itemtype="http://schema.org/logo" itemProp="logo" alt="Envision logo"
                image={envisionIcon}
                triggerAnchor={"#envision-logo"}
                animate={this.state.animate}
                offset={-20}
                whichAnimation={'fade-up'}
              />
        ENVISION
           </a>
            <button
              onClick={this.onClick}
              className="navbar-toggler" type="button" data-toggle="collapse" data-target="#collabsableContent" aria-controls="collabsableContent"
              aria-expanded="false" aria-label="Toggle navigation">
              <div className="animated-icon3">
                <span></span>
                <span></span>
                <span></span>
                <span></span></div>
            </button>
            <Collapse style={{ fontSize: '92%' }} isOpen={this.state.collapse} navbar>
              <NavbarNav left>
                <NavItem>
                  <NavLink style={{ fontSize:'1.6rem',
                                    fontWeight:'400',
                                    flexWrap:'nowrap'}}
                            to={jsonData.Header.NavigationTexts.serviceLink.link}>
                    {jsonData.Header.NavigationTexts.serviceLink.text}
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink style={{ fontSize:'1.6rem',
                                    fontWeight:'400',
                                    flexWrap:'nowrap'}}
                            to={jsonData.Header.NavigationTexts.blogLink.link}>
                    {jsonData.Header.NavigationTexts.blogLink.text}
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink style={{ fontSize:'1.6rem',
                                    fontWeight:'400',
                                    flexWrap:'nowrap'}}
                            to={jsonData.Header.NavigationTexts.aboutLink.link}>
                    {jsonData.Header.NavigationTexts.aboutLink.text}
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink style={{ fontSize:'1.6rem',
                                    fontWeight:'400',
                                    flexWrap:'nowrap'}}
                           to={jsonData.Header.NavigationTexts.contactLink.link}>
                    {jsonData.Header.NavigationTexts.contactLink.text}
                  </NavLink>
                </NavItem>
              </NavbarNav>
            </Collapse>
          </Container>
        </Navbar>
      </Router>
    );
  }
}

// This code renders the Navigation in place ;) from site-nav.hbr
const domContainer = document.getElementById('envision_navigation');
domContainer ? ReactDOM.render(<EnvisionNav animate={false}></EnvisionNav>, domContainer) : false;

const overrideHeaderStyles = css`
    padding-left: 1.8rem;
    padding-right: 1.8rem;
    font-size: 2.0rem;
  `

const overrideContainerStyles = css`
    padding-left: 0;
    margin-left:0 !important;
  `

  const navigationLinkStyles = {
    fontSize:'1.6rem',
    fontWeight:'400',
    flexWrap:'nowrap',
  };